import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { buildTimeStringFromTimestamp } from '../../../../../components/common/time/timeHelper'
import CheckRiskStatus from '../components/CheckRiskStatus'
import TimelineDotLine from '../components/TimelineDotLine'
import { KybUtils } from '../../../kyb.utils'

const CheckTimeline = ({ timelineCheck }) => {
  const { t } = useTranslation(['common'])
  const timeline = Array.isArray(timelineCheck) ? timelineCheck : []
  const hasChecks = timeline.length > 0
  const checkLength = timeline.length

  // Helper to format description - tries to translate if it's a check key
  const formatDescription = (description) => {
    if (!description) return '---'

    // Try to extract check key from description (e.g., "AMLDD_ESG Check for: 12345")
    const checkKeyMatch = description.match(/^([A-Z_]+)\s+Check for:/)
    if (checkKeyMatch) {
      const checkKey = checkKeyMatch[1]
      const translationKey = KybUtils.getTranslationKeyFromCheckKey(checkKey)
      const restOfDescription = description.substring(checkKeyMatch[0].length).trim()

      // Try to translate, fallback to original key if translation doesn't exist
      const translatedCheck = t(`common:${translationKey}`, { defaultValue: checkKey })
      return `${translatedCheck} ${t('common:checkFor')}: ${restOfDescription}`
    }

    return description
  }

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:timeline')}</Typography>
        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label={t('common:events')} />
      </Paper>
      {hasChecks &&
        timeline.map((item, index) => (
          <TimelineDotLine key={index}>
            <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:email')}</Typography>
                  <Typography variant="subtitle3">{item.email}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:type')}</Typography>
                  <Typography variant="subtitle3">{t(`common:${item.type}`)?.replace(/_/g, ' ')}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:description')}</Typography>
                  <Typography variant="subtitle3">{formatDescription(item.description)}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:status')}</Typography>
                  <Typography variant="subtitle3">{t(`common:${item.status}`)}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:date')}</Typography>
                  <Typography variant="subtitle3">{buildTimeStringFromTimestamp(item.createdAt)}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckTimeline
